import 'lazysizes';

require('prismjs/themes/prism-tomorrow.css');

import CustomLayout from './wrapPageElement';

export const wrapPageElement = CustomLayout;

export const onRouteUpdate = ({location}) => {
    console.log('new pathname', location.pathname);
    if (window.MathJax !== undefined) {
        MathJax.Hub.Queue(['Typeset', MathJax.Hub]);
    }
};
